import WindowImage from '../../assets/windows.png';
import MacImage from '../../assets/mac.png';
import IosImage from '../../assets/ios.png';
import AndroidImage from '../../assets/android.png';
import React from 'react';

interface DownloadItem {
    id: number;
    name: string;
    platform: string;
    status: 'available' | 'building';
    icon: string;
    downloadUrl?: string;
    toolTip?: React.ReactNode;
}

export const downloadItems: DownloadItem[] = [
    {
        id: 1,
        name: 'Windows下载',
        platform: 'Windows',
        status: 'available',
        icon: 'windows',
        downloadUrl: 'https://xiaohai.haier.net/obs/UpdatePackage/DownloadPage/%E6%99%BA%E8%83%BD%E5%8A%A9%E6%89%8B%E5%B0%8F%E6%B5%B7-win.exe',
        toolTip: React.createElement('div', { style: { maxWidth: 350 } }, [
            React.createElement('div', { key: 'req-title', style: { fontWeight: 'bold', marginBottom: 8, display: 'flex', whiteSpace: 'nowrap' } }, '建议配置：', [React.createElement('p', { key: 'os', style: { fontWeight: 'normal' } }, '不低于8核CPU、16GB内存')]),
            React.createElement('div', { key: 'req-title', style: { fontWeight: 'bold', display: 'flex', whiteSpace: 'nowrap' } }, '系统要求：', [React.createElement('p', { key: 'os', style: { fontWeight: 'normal' } }, 'Win10、Win11操作系统')]),
        ]),
    },
    {
        id: 2,
        name: 'Mac(Intel)',
        platform: 'Mac Intel',
        status: 'building',
        icon: 'mac-intel',
        downloadUrl: 'https://hdxtdown.haier.net/iHaier_F/Mac/7.6.7/iHaier2.0_7.6.7.dmg',
        toolTip: null,
    },
    {
        id: 3,
        name: 'Mac(M芯片)',
        platform: 'Mac M',
        status: 'building',
        icon: 'mac-m',
        downloadUrl: 'https://hdxtdown.haier.net/iHaier_F/Mac/7.6.7/M/iHaier2.0_7.6.6(M).dmg',
        toolTip: null,
    },
    {
        id: 4,
        name: 'iOS & iPad',
        platform: 'iOS',
        status: 'building',
        icon: 'ios',
        downloadUrl: 'itms-services://?action=download-manifest&amp;url=https://hdxtdown.haier.net/iHaier_F/IOS/plist/ihaier.plist',
        toolTip: null,
    },
    {
        id: 5,
        name: 'Android',
        platform: 'Android',
        status: 'building',
        icon: 'android',
        downloadUrl: 'https://hdxtdown.haier.net/iHaier_F/android/7.6.11/64/iHaier2.0_7.6.11_64.apk',
        toolTip: null,
    },
];

export const renderIcon = (iconType: string) => {
    switch (iconType) {
        case 'windows':
            return React.createElement('img', { src: WindowImage, alt: 'windows' });
        case 'mac-intel':
        case 'mac-m':
            return React.createElement('img', { src: MacImage, alt: 'mac' });
        case 'ios':
            return React.createElement('img', { src: IosImage, alt: 'ios' });
        case 'android':
            return React.createElement('img', { src: AndroidImage, alt: 'android' });
        default:
            return React.createElement('div', { className: 'platform-icon' }, '📱');
    }
};
